export { default } from './Checkbox';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Checkbox/index.js
// module id = 581
// module chunks = 121